import Vue from 'vue'
import moment from 'moment'

const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

const state = {
  check_from_question: false,
  check_from_address: false,
  check_from_getaddres: false,
  check_from_planuser: false,
  check_from_benefit: false,
  check_from_foreign: false,
  check_from_payment: false,
  check_from_paymethod: false,
  check_from_renew: false,
  check_from_tax: false,
}

const mutations = {
  CHECK_QUESTION(state, payload) {
    state.check_from_question = payload
  },
  CHECK_ADRESS(state, payload) {
    state.check_from_address = payload
  },
  CHECK_GET_ADRESS(state, payload) {
    state.check_from_getaddres = payload
  },
  CHECK_PLAN_USER(state, payload) {
    state.check_from_planuser = payload
  },
  CHECK_BENEFIT(state, payload) {
    state.check_from_benefit = payload
  },
  CHECK_FOREIGN(state, payload) {
    state.check_from_foreign = payload
  },
  CHECK_PAYMENT(state, payload) {
    state.check_from_payment = payload
  },
  CHECK_PAYMENT_METHOD(state, payload) {
    state.check_from_paymethod = payload
  },
  CHECK_RENEW(state, payload) {
    state.check_from_renew = payload
  },
  CHECK_TAX(state, payload) {
    state.check_from_tax = payload
  },
}

const actions = {
  setCheckQt({ commit }, data) {
    commit('CHECK_QUESTION', data)
  },
  setCheckAdd({ commit }, data) {
    commit('CHECK_ADRESS', data)
  },
  setCheckGetAdd({ commit }, data) {
    commit('CHECK_GET_ADRESS', data)
  },
  setCheckPlan({ commit }, data) {
    commit('CHECK_PLAN_USER', data)
  },
  setCheckBenefit({ commit }, data) {
    commit('CHECK_BENEFIT', data)
  },
  setCheckForeign({ commit }, data) {
    commit('CHECK_FOREIGN', data)
  },
  setCheckPayment({ commit }, data) {
    commit('CHECK_PAYMENT', data)
  },
  setCheckPaymentMethod({ commit }, data) {
    commit('CHECK_PAYMENT_METHOD', data)
  },
  setCheckRenew({ commit }, data) {
    commit('CHECK_RENEW', data)
  },
  setCheckTax({ commit }, data) {
    commit('CHECK_TAX', data)
  },
}

const getters = {
  getCheckApplication: state => () => {
    let temp
    // //console.log(
    //   state.check_from_question +
    //     " " +
    //     state.check_from_address +
    //     " " +
    //     state.check_from_getaddres +
    //     " " +
    //     state.check_from_planuser +
    //     " " +
    //     state.check_from_benefit +
    //     " " +
    //     state.check_from_foreign +
    //     " " +
    //     state.check_from_payment +
    //     " " +
    //     state.check_from_paymethod +
    //     " " +
    //     state.check_from_renew +
    //     " " +
    //     state.check_from_tax
    // );
    if (
      state.check_from_question == true &&
      state.check_from_address == true &&
      state.check_from_getaddres == true &&
      state.check_from_planuser == true &&
      state.check_from_benefit == true &&
      state.check_from_foreign == true &&
      state.check_from_payment == true &&
      state.check_from_paymethod == true &&
      state.check_from_renew == true &&
      state.check_from_tax == true
    ) {
      temp = true
    } else {
      temp = false
      // this._vm.$swal({
      //     type: "error",
      //     title: "กรุณากรอกข้อมูลให้ครบถ้วนค่ะ"
      // });
    }
    return temp
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
